import Image from 'app/Components/Shared/Image/image';


import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import SortingCallsPopUp from '../SortingCalls/SortingCallsPopUp';
import SortingCallsLabel from '../SortingCalls/SortingCallsLabel';

function CallsDetails(props) {

  return (
    <>
    <SortingCallsPopUp showPopUp={props.showSortingPopup} onClose={() => props.toggleSortingPopup(false)} sortingData={props.sortingData} onClickSaveSorting={props.onClickSaveSorting} onResetSort={props.onResetSort} />
    <div className='invoice-calls-details-wrapper'>
      { props.selectedSort.sortName && <SortingCallsLabel selectedSort={props.selectedSort} onClickRemoveSort={props.onClickRemoveSort} />}
      <div className='invoice-calls-details'>
      <div className='calls-details-header'>
        <h2>{props.callsDetails?.title}</h2>
        <button className='sorting-btn' onClick={() => props.toggleSortingPopup(true)}>
          <Image src={require('./images/arrow-up.svg')} alt='arrow-up' />
          <Image src={require('./images/arrow-down.svg')} alt='arrow-down' />
        </button>
      </div>
      <div className='calls-details-list'>
        {props.callsDetails?.calls?.map((item, index) => {
          return <div key={index} className='call-details-item'>
                <div className='call-details-right'>
                  <div className='date'>{item.dateText}</div>
                  <div className='subscriber-operator'>{item.subscriberNumber} | {item.operator}</div>
                  <div className='price-per-minute'>{item.pricePerMinute && <span> לפי תעריף לדקה ₪{item.pricePerMinute}</span>}</div>
                </div>
                <div className='call-details-left'>
                  <div className='source'>{item.source && item.source}</div>
                  <div className='duration'>{item.durationText}</div>
                  <div className='price'>₪{item.price}</div>
                </div>
          </div>
        })}
      </div>
      </div>
    </div>
    </>

  );
}

const mapStateToProps = (state) => {
  return {

  };
};
const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(CallsDetails);
